angular.module('stack.common.i18n.services.TranslationService', [
  'stack.common.i18n.models.TranslationModel'
])

/**
 * The TranslatorService service provides methods for managing
 * the translation of strings based upon different locales.
 *
 * @class TranslationService
 * @constructor
 * @module stack.common.i18n.TranslationService
 */
.factory('TranslationService', [
  'TranslationModel',
  function (TranslationModel) {
    'use strict';

    var service = {
      /**
       * Method searches translation map for the given input.
       *
       * @param {string} input - String to translate
       */
      translate: function translate(input) {
        return TranslationModel
          .get()
          .then(function (response) {
            return _.has(response, input) ? response[input] : input;
          });
      }
    };

    return service;
  }
]);
